import type { ApiClient } from '../../api/client';
import type { WorkflowDelegation, WorkflowSelfDelegationPort } from '../../features/workflow/public';

export function createWorkflowSelfDelegationHttpAdapter(client: ApiClient): WorkflowSelfDelegationPort {
  return {
    async list() {
      const result = await client.requestTenant<{ data: WorkflowDelegation[] }>('/api/hr/v1/{tenant}/me/delegations');
      return result.data;
    },
    create(input, idempotencyKey) {
      return client.requestTenant<WorkflowDelegation>('/api/hr/v1/{tenant}/me/delegations', {
        method: 'POST', headers: { 'Idempotency-Key': idempotencyKey }, body: JSON.stringify(input),
      });
    },
    revoke(id) {
      return client.requestTenant<WorkflowDelegation>(`/api/hr/v1/{tenant}/me/delegations/${encodeURIComponent(id)}/revoke`, { method: 'POST' });
    },
  };
}
